import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters(['searchTags', 'filterPanelOpen']),
    },

    watch: {
        searchTags: {
            immediate: true,
            handler: 'reloadValues',
        },

        filterPanelOpen(val) {
            if (val) {
                this.$nextTick(() => {
                    this.reloadValues()
                })
            }
        },
    },

    methods: {
        filter() {
            this.$store
                .dispatch('filter', JSON.parse(JSON.stringify(this.model)))
                .then(() => {
                    this.$store.dispatch('filterPanel', false)
                    this.$store.dispatch('searchClearTags')
                    Object.keys(this.model).map((key) => {
                        const value = this.model[key]
                        if (value != null && value != 0 && value != '')
                            if (
                                value.constructor !== Object ||
                                (value.constructor === Object &&
                                    Object.keys(value).length !== 0)
                            )
                                this.$store.dispatch('searchAddTag', {
                                    label: key,
                                    value: value,
                                })
                    })
                })
        },

        clear() {
            this.$store.dispatch('searchClearTags')
            this.$store.dispatch('search', '')
            this.$store.dispatch('clearFilters')
            Object.keys(this.model).map((key) => {
                this.model[key] = null
            })
            this.$store.dispatch('filterPanel', false)
        },

        reloadValues() {
            Object.keys(this.model).forEach((key) => {
                let value = null
                if (this.searchTags && this.searchTags.length) {
                    const current = this.searchTags.find(
                        (el) => el.label == key
                    )
                    if (current) value = current.value
                }
                if (key == 'modifier_ids' && !value) value = {}
                this.$set(this.model, key, value)
            })
        },
    },
}
